<template>
  <s-modal
    v-model="showModal"
    class="diagnostic-details-modal"
    size="xl"
    ok-only
    :title="titleHandler"
    :is-loading="loading"
    @ok="closeModal"
    @show="getDetails"
  >
    <b-container fluid>
      <b-row
        v-if="loading"
        class="diagnostic-details-modal__loader"
        align-h="center"
      >
        <s-loader
          class="my-5"
          size="lg"
        />
      </b-row>
      <b-row v-else>
        <s-table
          class="diagnostic-details-modal__table-wrapper"
          :responsive="false"
          :fields="fields"
          :items="diagnosticDetails"
        >
          <template #cell(generatesAlarm)="data">
            <alarm-status
              displaying
              :alarm-status="data.value"
            />
          </template>
          <template #cell(classification)="data">
            <div class="diagnostic-details-modal__classification-collumn">
              <classification
                displaying
                :classification="data.value"
              />
            </div>
          </template>
        </s-table>
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import { Modules } from 'sigma-mappings';
import DiagnosticService from '@/domain/services/generalPanel/adminPanel/diagnosticsConfigurations/diagnosticsConfigurations';
import Classification from '@/components/Classification';
import AlarmStatus from '@/components/AlarmStatus';
import LoadingMixin from '../../../../../services/loadingMixin';

export default {
  name: 'DiagnosticDetailsModal',
  components: {
    Classification,
    AlarmStatus,
  },
  mixins: [LoadingMixin],
  data: () => ({
    diagnosticDetails: [],
  }),
  props: {
    value: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    payload: {
      type: Object,
    },
    filter: {
      type: Object,
    },
    module: {
      type: String,
      default: '',
    },
  },
  computed: {
    isOscillographyAnalysis() {
      return this.module === Modules.OSCILLOGRAPHY_ANALYSIS;
    },
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    titleHandler() {
      const prefix = this.$t('diagnostics-configurations.diagnosis-detail');
      return `${prefix} - ${this.title}`;
    },
    fields() {
      return [
        {
          key: 'company.name',
          label: this.$t('entities.company'),
        },
        {
          key: 'regional.name',
          label: this.$t('entities.regional'),
        },
        {
          key: 'installation.name',
          label: this.$t('entities.installation'),
        },
        {
          key: 'asset.name',
          label: this.$t('entities.asset'),
        },
        ...(this.isOscillographyAnalysis ? [{
          key: 'setGroup',
          label: this.$t('diagnostics-configurations.set-group'),
        }] : []),
        {
          key: 'generatesAlarm',
          label: this.$t('diagnostics-configurations.alarm'),
        },
        {
          key: 'classification',
          label: this.$t('diagnostics-configurations.classification'),
          thClass: 'diagnostic-details-modal__table-classification text-center',
          tdClass: 'diagnostic-details-modal__table-classification text-center',
        },
      ];
    },
  },
  methods: {
    getDetails() {
      const { filter } = this;
      const { id } = this.payload;
      const params = {
        diagnosticId: id,
        assets: { ...filter.targetAssets },
      };
      const request = this.isOscillographyAnalysis
        ? DiagnosticService.getOscillographyAnalysisDetails(params)
        : DiagnosticService.getChromaDetails(params);

      this.startLoading();
      request
        .then((data) => {
          this.diagnosticDetails = data;
        })
        .finally(() => this.endLoading());
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
<style lang="sass" scoped>
  .diagnostic-details-modal
    ::v-deep &__table
      &-classification
        min-width: 145px
    &__table-wrapper
      max-height: 50vh
      overflow-y: auto
      ::v-deep
        .table-responsive
          overflow-x: hidden

    &__classification-collumn
      display: flex
      justify-content: center
      > span
</style>
